<template lang="pug">
.become-advertiser
  template(v-if="sent")
    .become-advertiser__thanks
      .become-advertiser__thanks-title(v-t="'becomeAdvertiserThanksTitle'")
      .become-advertiser__thanks-text(v-t="'becomeAdvertiserThanksText'")
      Button.become-advertiser__thanks-button(is-primary @click="close") {{ $t("buttonClose") }}

  template(v-else)
    Breadcrumbs(:list="breadcrumbs")
    .become-advertiser__start
      p.become-advertiser__h1(v-html="$t('becomeAdvertiserH1')")
      .become-advertiser__partners
        img.become-advertiser__partners-img(:src='require("~/assets/img/become-advertiser/partners.png")' alt='partners')

    .become-advertiser__body
      h2.become-advertiser__h2(v-t="'becomeAdvertiserOurServices'")

      .become-advertiser__services
        .become-advertiser__service(v-for="service in services" :key="service.id")
          .become-advertiser__service-left
            span.become-advertiser__service-number {{ service.id }}
            span.become-advertiser__service-link(v-t="'becomeAdvertiserLearnMore'" @click="setSlide(+service.id - 1)")
          span.become-advertiser__service-text(v-t="service.text")

      .become-advertiser__service
        p.become-advertiser__service-info(v-html="$t('becomeAdvertiser24Metrics')")

      Button.become-advertiser__order(is-primary @click="toForm") {{ $t("becomeAdvertiserOrder") }}

      .become-advertiser__video-container(ref="slide")
        h2.become-advertiser__h2(v-t="'becomeAdvertiserHowItWorks'")
        iframe.become-advertiser__video(width="100%" height="315" src="https://www.youtube.com/embed/kRLKfobxpR4")

      .become-advertiser__slide
        h2.become-advertiser__h2(v-t="slide.title")
        .become-advertiser__slide-main
          .become-advertiser__slide-content(v-html="$t(slide.content)")
          img.become-advertiser__slide-img(:src="slide.image" alt="background")
        Button.become-advertiser__order(is-primary @click="toForm") {{ $t("becomeAdvertiserOrder") }}
        .become-advertiser__slider
          .become-advertiser__slider-element-container(v-for="(_, i) in slides")
            .become-advertiser__slider-element(@click="setSlide(i)" :class="{'become-advertiser__slider-element--active': i === slideIndex}")

      h2.become-advertiser__h2.become-advertiser__h2--white(v-t="'becomeAdvertiserIssuesWeSolve'")

      .become-advertiser__issues.become-advertiser__issues--mobile
        .become-advertiser__issue(v-for="issue in currentIssues" :key="issue.id")
          .become-advertiser__issue-text(v-t="issue.text")
      .become-advertiser__issues.become-advertiser__issues--desktop
        .become-advertiser__issue(v-for="issue in issues" :key="issue.id")
          .become-advertiser__issue-text(v-t="issue.text")
      .become-advertiser__slider.become-advertiser__slider--issues
        .become-advertiser__slider-element-container(v-for="(_, i) in issuesPagesAmount")
          .become-advertiser__slider-element(@click="setIssuesPage(i)" :class="{'become-advertiser__slider-element--active': i === issuesPageIndex}")

      .become-advertiser__solve-container
        img.become-advertiser__partners-img(:src='require("~/assets/img/become-advertiser/phone.png")' alt="phone")
        div
          .become-advertiser__solve-label(v-t="'becomeAdvertiserSolve'")
          .become-advertiser__solve(v-t="'becomeAdvertiserSolveHeader'")
      Button.become-advertiser__solve-button(is-primary @click="toForm") {{ $t("becomeAdvertiserOrder") }}

      .become-advertiser__24m
        h2.become-advertiser__h2(v-t="'becomeAdvertiserHeader24Metrics'")
        p.become-advertiser__slide-content(v-t="'becomeAdvertiser24MetricsText'")

      .become-advertiser__form(ref="form")
        p.become-advertiser__form-header(v-html="$t('becomeAdvertiserFormHeader')")

        .become-advertiser__form-body
          input.become-advertiser__form-body-input(:placeholder="$t('becomeAdvertiserYourName')" v-model="name")
          select.become-advertiser__form-body-input(v-model="service")
            option(disabled value="") {{ $t('becomeAdvertiserChooseService') }}
            option(value="ASO") ASO
            option(value="CPA") CPA
            option(value="UGC") UGC
            option(value="Sponsorship") Sponsorship
            option(value="Other") Other
          input.become-advertiser__form-body-input(placeholder="Email" v-model="email")
          input.become-advertiser__form-body-input(:placeholder="$t('becomeAdvertiserChooseContactType')" v-model="contactType")
          textarea.become-advertiser__form-body-input.become-advertiser__form-body-input--big(:placeholder="$t('becomeAdvertiserComment')" v-model="comment" rows="5")

          Button.become-advertiser__order.become-advertiser__form-body-button(is-primary :disabled="sendButtonDisabled" @click="sendOrder") {{ $t('becomeAdvertiserOrder') }}

  PageArticle(v-if="article" :content="article")
</template>

<script>
import BecomeAdvertiserService from '@/services/BecomeAdvertiserService'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import PageArticle from '@/components/MarketplaceComponents/PageArticle'
import { createMeta } from '~/utils/meta'

export default {
  components: {
    Breadcrumbs,
    PageArticle
  },

  layout: 'clear',

  data () {
    return {
      name: '',
      service: '',
      email: '',
      contactType: '',
      comment: '',
      sent: false,
      services: [
        {
          id: '01',
          text: 'becomeAdvertiserService1Text'
        },
        {
          id: '02',
          text: 'becomeAdvertiserService2Text'
        },
        {
          id: '03',
          text: 'becomeAdvertiserService3Text'
        },
        {
          id: '04',
          text: 'becomeAdvertiserService4Text'
        }
      ],
      slides: [
        {
          id: 'slide1',
          title: 'becomeAdvertiserSlide1Title',
          content: 'becomeAdvertiserSlide1Content',
          image: require('~/assets/img/become-advertiser/become-adv-slide-1.png')
        },
        {
          id: 'slide3',
          title: 'becomeAdvertiserSlide3Title',
          content: 'becomeAdvertiserSlide3Content',
          image: require('~/assets/img/become-advertiser/become-adv-slide-3.png')
        },
        {
          id: 'slide2',
          title: 'becomeAdvertiserSlide2Title',
          content: 'becomeAdvertiserSlide2Content',
          image: require('~/assets/img/become-advertiser/become-adv-slide-2.png')
        },
        {
          id: 'slide4',
          title: 'becomeAdvertiserSlide4Title',
          content: 'becomeAdvertiserSlide4Content',
          image: require('~/assets/img/become-advertiser/become-adv-slide-4.png')
        }
      ],
      slideIndex: 0,
      issues: [
        {
          id: 'issue1',
          text: 'becomeAdvertiserIssue1Text'
        },
        {
          id: 'issue2',
          text: 'becomeAdvertiserIssue2Text'
        },
        {
          id: 'issue3',
          text: 'becomeAdvertiserIssue3Text'
        },
        {
          id: 'issue4',
          text: 'becomeAdvertiserIssue4Text'
        },
        {
          id: 'issue5',
          text: 'becomeAdvertiserIssue5Text'
        },
        {
          id: 'issue6',
          text: 'becomeAdvertiserIssue6Text'
        },
        {
          id: 'issue7',
          text: 'becomeAdvertiserIssue7Text'
        },
        {
          id: 'issue8',
          text: 'becomeAdvertiserIssue8Text'
        },
        {
          id: 'issue9',
          text: 'becomeAdvertiserIssue9Text'
        },
        {
          id: 'issue10',
          text: 'becomeAdvertiserIssue10Text'
        },
        {
          id: 'issue11',
          text: 'becomeAdvertiserIssue11Text'
        },
        {
          id: 'issue12',
          text: 'becomeAdvertiserIssue12Text'
        },
        {
          id: 'issue13',
          text: 'becomeAdvertiserIssue13Text'
        },
        {
          id: 'issue14',
          text: 'becomeAdvertiserIssue14Text'
        },
        {
          id: 'issue15',
          text: 'becomeAdvertiserIssue15Text'
        },
        {
          id: 'issue16',
          text: 'becomeAdvertiserIssue16Text'
        },
        {
          id: 'issue17',
          text: 'becomeAdvertiserIssue17Text'
        },
        {
          id: 'issue18',
          text: 'becomeAdvertiserIssue18Text'
        }
      ],
      issuesPageIndex: 0
    }
  },

  computed: {
    article () {
      if (this.$i18n.locale.includes('en')) {
        return '<h2>Welcome to gaming-goods.com: High-Performance Marketing and Mobile App Promotion</h2> <p>Welcome to the world of high-efficiency marketing and mobile app promotion through incentivized traffic! If you\'re a business or entrepreneur looking to attract motivated traffic for reward-based tasks, you\'re in the right place. We offer unique solutions for optimizing and promoting your apps in the Google Play and App Store, ensuring high-quality traffic and zero fraud.</p> <h3>Why Choose Our Services?</h3> <h4>ASO Optimization and Top Rankings</h4> <p>ASO (App Store Optimization) is a key tool for improving your app’s visibility in app stores. We provide the necessary downloads to boost your ranking and visibility in search results. With our services, your app can quickly reach top positions and attract more targeted users.</p> <h4>Reviews and Reputation</h4> <p>Reviews play a crucial role in building your app’s reputation. We offer services to generate positive reviews from real users, which helps increase trust and downloads. Our methods guarantee no fraud and ensure the authenticity of every review.</p> <h4>High-Quality Traffic</h4> <p>Our traffic solutions guarantee high-quality, targeted users. We use only proven methods to ensure natural audience growth and high app trustworthiness.</p> <h4>App Promotion</h4> <p>We offer a full range of app promotion services, including SEO strategies, social media marketing, and other tools to increase visibility and downloads. Our case studies and successful projects demonstrate the effectiveness of our methods.</p> <h3>Our Services</h3> <h4>ASO Promotion</h4> <p>We offer comprehensive ASO promotion services, including keyword selection, metadata optimization, and creating compelling descriptions. Our experts will help you achieve high app store rankings and attract more users.</p> <h4>Attracting Real Users</h4> <p>Our platform allows you to attract real users for reward-based tasks. This can include app downloads, leaving reviews, or performing other actions that will help your app climb the rankings, including reaching specific levels in your game, deposits, CPA, CPE, and CPI tasks.</p> <h4>Models and Strategies</h4> <p>We develop customized promotion models and strategies tailored to your app’s specific features and target audience. Our methods include using offers, advertising campaigns, and other tools to achieve maximum results.</p> <h4>Social Media and Web Services</h4> <p>We offer services for promoting your app on social media and web platforms to increase reach and brand awareness. Our specialists will help you create effective advertising campaigns and attract new audiences.</p> <h4>Affiliate Programs</h4> <p>We offer profitable conditions for partners and agencies looking to collaborate with us. Our affiliate programs allow you to earn additional income by attracting new clients and promoting their apps.</p> <h3>Why Our Services Are Effective?</h3> <h4>No Fraud</h4> <p>We guarantee no fraud and the authenticity of every user. Our methods and tools ensure high-quality traffic and reliable data.</p> <h4>High Visibility and Rankings</h4> <p>Our ASO optimization and app promotion services help you achieve high rankings in app stores, leading to more downloads and better visibility.</p> <h3>How We Work</h3> <h4>Analysis and Strategy</h4> <p>We start by analyzing your app and target audience to develop an effective promotion strategy. Our experts conduct in-depth research and select the best methods to achieve your goals.</p> <h4>Optimization and Promotion</h4> <p>We carry out ASO optimization and launch advertising campaigns to increase your app’s visibility and downloads. Our methods include keyword usage, creating attractive descriptions, and other tools to improve rankings.</p> <h4>Monitoring and Analyzing Results</h4> <p>We monitor the promotion results and analyze the data to optimize strategies. Our specialists constantly track changes and adjust methods to achieve the best outcomes.</p> <h4>Support and Assistance</h4> <p>We provide full support and assistance throughout the promotion process. Our experts are ready to answer any questions and help solve any issues you may encounter.</p> <h3>Benefits of Working with Us</h3> <h4>Low Commissions</h4> <p>We offer the lowest transaction fees, allowing you to save on promoting your app.</p> <h3>Join Us</h3> <p>If you want to effectively promote your apps and attract new users, join us at gaming-goods.com. We offer unique solutions for ASO optimization and app promotion, guaranteeing high-quality traffic and no fraud. Our services will help you reach new heights and increase your app’s revenue.</p> <p>Don’t miss the opportunity to enhance your gaming experience and reach new heights in the mobile app world with our services. Join gaming-goods.com and start attracting motivated traffic for reward-based tasks today!</p>'
      }

      return undefined
    },

    slide () {
      return this.slides[this.slideIndex]
    },

    issuesPagesAmount () {
      return Math.ceil(this.issues.length / 6)
    },

    currentIssues () {
      return this.issues.slice(this.issuesPageIndex * 6, (this.issuesPageIndex + 1) * 6)
    },

    breadcrumbs () {
      return [
        {
          title: this.$t('becomeAdvertiserTitle')
        }
      ]
    },

    sendButtonDisabled () {
      return !this.name || this.name === '' || !this.service || this.service === '' || !this.email || this.email === '' || !this.contactType || this.contactType === ''
    }
  },

  methods: {
    setSlide (i) {
      this.slideIndex = i
      this.toSlide()
    },

    setIssuesPage (i) {
      this.issuesPageIndex = i
    },

    sendOrder () {
      if (this.sendButtonDisabled) {
        return
      }

      this.sent = true
      // this.$gtag.event('send_request_to_become_an_advertiser', {})
      BecomeAdvertiserService.sendForm(this.$axios, this.name, this.email, this.contactType, this.service, this.comment)
    },

    close () {
      this.$router.push(this.localeLocation('/'))
    },

    toForm () {
      this.$refs.form.scrollIntoView({ behavior: 'smooth' })
    },

    toSlide () {
      this.$refs.slide.scrollIntoView({ behavior: 'smooth' })
    }
  },

  head () {
    if (this.$i18n.locale.includes('en')) {
      return createMeta.call(this, {
        title: 'ASO Mobile App Optimization | App Store Promotion',
        description: 'Promote your apps in Google Play and App Store. Mobile app marketing. Improve rankings and achieve top listings. Full-service results-driven approach. Any geos. Active case studies. Mobile app promotion.',
        sharingTitle: 'ASO Mobile App Optimization | App Store Promotion',
        sharingDescription: 'Promote your apps in Google Play and App Store. Mobile app marketing. Improve rankings and achieve top listings. Full-service results-driven approach. Any geos. Active case studies. Mobile app promotion.',
        keywords: 'app promotion,aso optimization,reviews,reputation,points,google play,appstore,ios,android,market,app store,top ranking,boosting,real users,users,search results,targeted query,no fraud,fraud-free,collaboration,partner,traffic,quality,non-incentivized,app promotion,mobile,services,strategy,cases,web,web,services,social networks,agency,seo,methods,tool,turnkey,ranking,top,search query,visibility position,recommended,categories,selection,offer,tasks,models,marketing,advertising,high downloads,natural growth,audience,hit,first place,to the top,list,monetization,development,geo,assistance,internet,brand awareness,reaches,growth,app promotion,custom,aso promotion,apps to the top,on google play,aso buy,download,downloads,target hit,trustworthiness,counter,large,internet,full cycle,to the result,targeted,similar,competitor bypass,functionality,app clients,new audiences,niche,clients,users'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.become-advertiser {
  $page-color: #5A73FF;
  width: 100%;
  padding: 50px 0 67px;
  background: $blue-grey80;

  @media (min-width: $breakpointTablet) {
    padding: 70px 0;
  }

  @media (min-width: $breakpointDesktopWide) {
    max-width: 1309px;
    margin: auto;
  }

  &__start {
    @media (min-width: $breakpointDesktopWide) {
      display: grid;
      grid-template-columns: 2fr 3fr;
      grid-gap: 20px;
      align-items: center;
    }
  }

  &__h1 {
    margin: 16px 0 50px;
    color: $white;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;

    @media (min-width: $breakpointTablet) {
      font-size: 50px;
      line-height: 46px;
      max-width: 610px;
      margin: 0 auto 80px;
    }
  }

  &__partners {
    margin: 12px 5px;

    &-img {
      width: 100%;
    }
  }

  &__body {
    padding: 0 16px;

    @media (min-width: $breakpointTablet) {
      padding: 0 40px;
    }
  }

  &__h2 {
    color: $page-color;
    font-size: 26px;
    font-weight: 700;
    line-height: 27px;
    margin-bottom: 25px;
    margin-top: 50px;

    @media (min-width: $breakpointTablet) {
      margin: 65px 0 40px;
      font-size: 36px;
      font-weight: 700;
      line-height: 36px;
    }

    &--white {
      color: $white;
      text-align: center;
    }
  }

  &__services {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    margin-bottom: 20px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 18px;
      margin-bottom: 36px;
    }
  }

  &__service {
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-gap: 35px;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid $blue-grey50;
    background: $blue-grey70;

    &-left {
      display: flex;
      flex-direction: column;
    }

    &-number {
      background: linear-gradient(180deg, #5C6BC0 0%, #3949AB 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 40px;
      font-weight: 700;
      line-height: 40px;
    }

    &-text {
      color: $white;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    &-link {
      margin-top: 7px;
      color: $page-color;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      text-decoration-line: underline;
      cursor: pointer;
    }

    &-info {
      color: $white;
      text-align: center;
      grid-column: 1 / 3;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;

      @media (min-width: $breakpointTablet) {
        padding: 22px 80px;
        font-size: 25px;
        font-weight: 500;
        line-height: 26px;
      }
    }
  }

  &__order {
    margin: 20px auto;
    min-width: 160px;

    @media (min-width: $breakpointTablet) {
      margin: 36px auto;
      height: 60px;
      min-width: 260px;
    }
  }

  &__slide {
    color: $white;

    &-main {
      @media (min-width: $breakpointTablet) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 40px;
      }
    }

    &-img {
      margin-top: 20px;
      width: 100%;
      max-height: 450px;
      object-fit: contain;

      @media (min-width: $breakpointTablet) {
        margin: 0;
      }
    }

    &-content {
      color: $white;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;

      @media (min-width: $breakpointTablet) {
        font-size: 20px;
      }

      &::v-deep ol {
        display: block;
        list-style-type: decimal !important;
        margin-top: 1em;
        margin-bottom: 1em;
        margin-left: 0;
        margin-right: 0;
        padding-left: 40px;
      }

      &::v-deep li {
        list-style-type: decimal !important;
      }
    }
  }

  &__slider {
    display: grid;
    grid-template-columns: repeat(4, 35px);
    grid-gap: 8px;
    margin: 25px auto;
    width: max-content;

    &--issues {
      @media (min-width: $breakpointTablet) {
        display: none;
      }
    }

    &-element {
      height: 3px;
      border-radius: 10px;
      background: $blue-grey20;
      cursor: pointer;

      &--active {
        background: $page-color;
        cursor: auto;
      }
    }
  }

  &__issues {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 10px 21px;
    }

    &--mobile {
      @media (min-width: $breakpointTablet) {
        display: none;
      }
    }

    &--desktop {
      display: none;

      @media (min-width: $breakpointTablet) {
        display: grid;
      }
    }
  }

  &__24m {
    @media (min-width: $breakpointTablet) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 23px;
      margin-top: 40px;

      .become-advertiser__h2 {
        margin: 0;
      }
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-gap: 100px;
      margin-bottom: 60px;
    }
  }

  &__issue {
    padding: 16px;
    background: rgba($page-color, 0.5);
    color: $white;
    font-size: 12px;
    font-weight: 500;
    line-height: 12px;
    border-radius: 10px;
  }

  &__video {
    border-radius: 14px;
    border: 0.526px solid #2B3848;

    &-container {
      @media (min-width: $breakpointTablet) {
        display: grid;
        grid-template-columns: 2fr 3fr;
        margin: 75px 0;

        .become-advertiser__h2 {
          margin: 0;
        }
      }
    }
  }

  &__solve {
    text-align: right;
    width: 235px;
    margin-bottom: 25px;
    margin-left: auto;
    color: $white;
    font-size: 26px;
    font-weight: 700;
    line-height: 27px;

    @media (min-width: $breakpointDesktopWide) {
      font-size: 64px;
      line-height: 64px;
      width: auto;
      max-width: 700px;
    }

    &-container {
      display: grid;
      grid-template-columns: 1fr max-content;
      grid-gap: 4px;

      @media (min-width: $breakpointTablet) {
        grid-template-columns: 200px 1fr;
      }

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: 1fr 2fr;
      }
    }

    &-label {
      color: $white;
      margin: 50px 0 25px;
      text-align: right;
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
    }

    &-button {
      margin-left: auto;
    }
  }

  &__form {
    margin-top: 50px;

    @media (min-width: $breakpointDesktopWide) {
      max-width: 1000px;
      margin: 50px auto 0;
    }

    &-header {
      color: $white;
      padding: 0 20px;
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 25px;
      text-align: center;

      @media (min-width: $breakpointTablet) {
        font-size: 25px;
        font-weight: 700;
        line-height: 26px;
        max-width: 450px;
        margin: 0 auto 30px;
      }
    }

    &-body {
      border-radius: 20px;
      border: 1px solid $blue-grey50;
      background: $blue-grey70;
      padding: 20px;

      @media (min-width: $breakpointTablet) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 15px 18px;
        align-items: center;
      }

      &-input {
        width: 100%;
        margin-bottom: 10px;
        border-radius: 8px;
        border: 1px solid $blue-grey50;
        background: rgba(20, 30, 43, 0.30);
        padding: 12px 15px;
        font-size: 12px;
        font-weight: 500;
        line-height: 130%;
        color: rgba(#EFF3FF, 0.5);

        @media (min-width: $breakpointTablet) {
          margin: 0;
        }

        &--big {
          height: 80px;

          @media (min-width: $breakpointTablet) {
            grid-column: 1 / 3;
          }
        }
      }

      &-button {
        &:disabled {
          opacity: 0.5;
        }

        @media (min-width: $breakpointTablet) {
          grid-column: 1 / 3;
          margin: auto;
        }
      }
    }
  }

  &__thanks {
    margin: 20px 40px;
    text-align: center;

    &-title {
      margin-top: 20px;
      margin-bottom: 80px;
      color: $page-color;
      font-size: 26px;
      font-weight: 700;
      line-height: 27px;
      text-align: center;
    }

    &-text {
      margin-bottom: 80px;
      color: $white;
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
    }

    &-button {
      margin: auto;
    }
  }
}
</style>
